export const statusEnum = {
  ACTIVE: 'ACTIVE',
  DELETED: 'DELETED',
} as const

export type StatusEnum = (typeof statusEnum)[keyof typeof statusEnum]

export type Status = StatusEnum